<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">
        <a-form-model-item
            prop="text"
          label="字典项文本">
          <a-input placeholder="请输入字典项文本" v-model="model.text" />
        </a-form-model-item>
        <a-form-model-item
            prop="value"
          label="字典项值">
          <a-input placeholder="请输入字典项值" v-model="model.value" />
        </a-form-model-item>
        <a-form-model-item
            prop="sortOrder"
          label="排序">
          <a-input-number v-model="model.sortOrder" :min="0" :precision="0" style="width: 100%" placeholder="请输入排序" />
        </a-form-model-item>
        <a-form-model-item
          prop="description"
          label="描述">
          <a-textarea :rows="2" placeholder="请输入描述" v-model="model.description" />
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction } from '@/api/manage'
  import baseRules from '@/constants/baseRules'

  export default {
    name: "ProjectDictItemModal",
    props:{
      dict:{
        type:Object,
        default:()=>{
          return {}
        }
      }
    },
    data () {
      return {
        title:"操作",
        visible: false,
        model: {},
        rules:{
          text:[baseRules.required],
          value:[baseRules.required],
          sortOrder:[baseRules.required],
        },
        confirmLoading: false,

        url: {
          add: "/project/projectDictItem/add",
          edit: "/project/projectDictItem/edit",
        },
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({dictId:this.dict.id,sortOrder:1,projectId:this.dict.projectId});
      },
      edit (record) {
        if(!record.dictId){
          return this.$message.warning('请选择一个字典进行操作')
        }
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = this.model;

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          } else {
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>

<style lang="less" scoped>

</style>